import { fetcher } from '@kaiku/shared'

const API_ROOT = '/api/users'

export const adminLogin = ( body ) => fetcher( `${API_ROOT}/admin/login`, { method: 'POST', body } )

export const getReferralCodeUrl = () => `${API_ROOT}/referrals`
